<template>
  <div>
    <b-card
      :key="product.productid"
      :ref="'svc' + product.productid"
      @click="$emit('productSelect', product.productid)"
      :style="'height: max-content'"
      :body-class="
        'rounded' +
        (isActive ? ' outline-' + product.class : '') +
        (selectedProduct != null &&
        selectedProduct.productid === product.productid
          ? ' adjustForSelected'
          : '')
      "
      :class="
        'flexi-' + product.class +
        (selectedProduct != null &&
        selectedProduct.productid === product.productid
          ? ' selectedOutline'
          : ' flexi-hover-' + product.class)
      "
    >
      <b-card-header :class="'flexi-' + product.class + '-header'">{{
        product.name
      }}</b-card-header>
      <slot name="description">
        <div class="ml-3 mr-2 mt-3">
          {{ product.devices != null ? product.devices : "Unlimited" }} devices
          <br />
          Upload {{ product.upDescription }}
          <br />
          Download {{ product.downDescription }}
          <br />
          <span style="display: inline-block"> Daily cost of {{ product.credits }} credits</span>
        </div>
        <span v-if="activeproduct != null && minimumCredits > 1" style="display: inline-block" class="ml-3 mr-2"
          >Minimum purchase of {{ minimumCredits }} credits
        </span>
        <span v-else style="display: inline-block" class="ml-3 mr-2">
        </span>
        <br />
      </slot>
      <slot name="action"></slot>
    </b-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: "AdjustFlexiCard",
  props: {
    product: {
      type: Object, // name, descripion, class
      required: true,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    selectedProduct: {
      type: Object,
      default: null,
    },
    minimumCredits: {
      type: Number,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      activeproduct: "plan/getActiveProduct",
      activeuntil: "plan/getActiveUntil"
    }),
  }
};
</script>

<style lang="scss">
.flexi-svc1 {
  background: linear-gradient(to right, #373b44, #38AADE) !important;
  color: #ffffff;
  border-radius: 20px 20px 20px 20px;
  height: 100%;
  margin: 0.3rem;
  width: 17rem;
  min-width: 16rem;
  max-width: 20rem;
}
.flexi-svc2 {
  background: linear-gradient(to right, #a1540b, #EE811A) !important;
  color: #ffffff;
  border-radius: 20px 20px 20px 20px !important;
  height: 100%;
  margin: 0.3rem;
  width: 17rem;
  min-width: 16rem;
  max-width: 20rem;
}
.flexi-svc3 {
  background: linear-gradient(to right, #517043, #5DB12F) !important;
  color: #ffffff;
  border-radius: 20px 20px 20px 20px;
  height: 100%;
  margin: 0.3rem;
  width: 17rem;
  min-width: 16rem;
  max-width: 20rem;
}
.flexi-svc4, .flexi-svc5 {
  background: linear-gradient(to right, #a08b00 5%, mix(#a08b00, #cdb970, 50%) 20%, #cdb970 40%) !important;
  color: #ffffff;
  border-radius: 20px 20px 20px 20px;
  height: 100%;
  margin: 0.3rem;
  width: 17rem;
  min-width: 16rem;
  max-width: 20rem;
}

.flexi-svc1-header {
  border: solid white 2px;
  background: linear-gradient(to left, #526797, #3f66ad) !important;
  border-radius: 14px 14px 14px 14px !important;
  box-shadow: 8px 6px 8px #373b44;
}

.flexi-svc2-header {
  border: solid white 2px;
  background: linear-gradient(to left, #a75a12, #EE811A) !important;
  border-radius: 14px 14px 14px 14px !important;
  box-shadow: 8px 6px 8px #373b44;
}

.flexi-svc3-header {
  border: solid white 2px;
  background: linear-gradient(to left, #79a560, #5DB12F) !important;
  border-radius: 14px 14px 14px 14px !important;
  box-shadow: 8px 6px 8px #373b44;
}

.flexi-svc4-header, .flexi-svc5-header {
  border: solid white 2px;
  background: linear-gradient(to left, #867a50, #ccba78) !important;
  border-radius: 14px 14px 14px 14px !important;
  box-shadow: 8px 6px 8px #373b44;
}

.selectedOutline {
  border: yellowgreen 8px solid;
}

.adjustForSelected {
  margin: -7px;
}

</style>